import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormArray } from '@angular/forms';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { Subscription } from 'rxjs';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';

@Component({
  selector: 'app-configuracion-documento-botonera',
  templateUrl: './configuracion-documento-botonera.component.html',
  styleUrls: ['./configuracion-documento-botonera.component.css']
})
export class ConfiguracionDocumentoBotoneraComponent implements OnInit, OnDestroy {

  icono: string = 'icon-arrow-forward';
  titulo: string = 'Siguiente';
  botonDeshabilitado = false;
  @Input() id: string;
  @Input() botonAccion: boolean = true;
  @Output() botonClicked: EventEmitter<any> = new EventEmitter<any>();
  @Input() index: number;
  firmanteValidadorSubscripcion: Subscription;
  private firmantesNifSubscription: Subscription;
  private firmaPanelSubscription: Subscription;
  private firmantesNifVinculado: FormArray | null = null;

  constructor(
    private _snackBar: MatSnackBar,
    private formularioDocumentoService: FormularioDocumentoService,
    private datosConfiguracionDocumentoService: DatosConfiguracionDocumentosService,
    private cdr: ChangeDetectorRef
  ) {
    this.getUsuarioActivoEditado();
  }

  get esRLT(){ return this.formularioDocumentoService.formularioDocumento.controls['esRLT']}
  get firmantesNif(){ return this.formularioDocumentoService.firmantesNif as FormArray}

  ngOnChanges(changes: SimpleChanges){
    if (changes.index) {
      this.vincularFirmantesNif();
      this.actualizarEstadoBoton();
    }
  }

  ngOnInit(): void {
    this.vincularFirmantesNif();
    this.firmaPanelSubscription = this.formularioDocumentoService.firmaPanelChanged().subscribe(() => {
      this.vincularFirmantesNif();
      this.actualizarEstadoBoton();
    });
    this.actualizarEstadoBoton();
  }

  ngOnDestroy(): void {
    this.firmanteValidadorSubscripcion?.unsubscribe();
    this.firmantesNifSubscription?.unsubscribe();
    this.firmaPanelSubscription?.unsubscribe();
  }

  atras(){
    this.botonClicked.emit('atras');
  }

  clicked(){
    if (this.botonDeshabilitado) {
      this._snackBar.open('Hay errores: faltan firmas por completar.', 'Cerrar', { duration: 3000 });
      return;
    }
    if(this.index == 1) {
      this._snackBar.open(`Se tiene que subir un documento para poder continuar`,'Cerrar', {duration: 3000})
      this.botonClicked.emit()
    }else{
      this.botonClicked.emit(this.titulo)
    }
  }

  getUsuarioActivoEditado(){
    this.firmanteValidadorSubscripcion = this.datosConfiguracionDocumentoService.datosValidador$.subscribe(() => {
      this.actualizarEstadoBoton();
    });
  }

  private vincularFirmantesNif(): void {
    const firmantesNif = this.firmantesNif;
    if (!firmantesNif || firmantesNif === this.firmantesNifVinculado) {
      return;
    }
    this.firmantesNifSubscription?.unsubscribe();
    this.firmantesNifVinculado = firmantesNif;
    this.firmantesNifSubscription = firmantesNif.valueChanges.subscribe(() => {
      this.actualizarEstadoBoton();
    });
  }

  private actualizarEstadoBoton(): void {
    this.vincularFirmantesNif();
    this.actualizarTituloBoton();
    this.botonDeshabilitado = this.index === 8 && !this.formularioDocumentoService.todosFirmantesConFirmaCompleta();
    this.cdr.markForCheck();
  }

  private actualizarTituloBoton(): void {
    if (
      this.index === 8 ||
      (this.esRLT?.value && this.index === 8)
    ) {
      this.titulo = 'Finalizar';
      return;
    }
    this.titulo = 'Siguiente';
  }

}
